import { useState } from 'preact/hooks';
import styles from './PhaseJumpPill.module.css';

interface PhaseEntry {
  /** Group identity — what `onJumpTo` receives. Not always the display name. */
  key: string;
  phase: string;
  count: number;
}

interface PhaseJumpPillProps {
  phases: PhaseEntry[];
  onJumpTo: (key: string) => void;
}

export function PhaseJumpPill({ phases, onJumpTo }: PhaseJumpPillProps) {
  const [open, setOpen] = useState(false);

  if (phases.length < 2) return null;

  return (
    <div class={styles.container}>
      {open && (
        <>
          <div class={styles.backdrop} onClick={() => setOpen(false)} />
          <div class={styles.popover}>
            {phases.map((entry) => (
              <button
                key={entry.key}
                type="button"
                class={styles.popoverItem}
                onClick={() => {
                  onJumpTo(entry.key);
                  setOpen(false);
                }}
              >
                <span class={styles.popoverPhase}>{entry.phase}</span>
                <span class={styles.popoverCount}>{entry.count}</span>
              </button>
            ))}
          </div>
        </>
      )}

      <button
        type="button"
        class={styles.pill}
        onClick={() => setOpen(!open)}
        aria-label="Jump to phase"
        title="Jump to phase"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="8" y1="6" x2="21" y2="6" />
          <line x1="8" y1="12" x2="21" y2="12" />
          <line x1="8" y1="18" x2="21" y2="18" />
          <line x1="3" y1="6" x2="3.01" y2="6" />
          <line x1="3" y1="12" x2="3.01" y2="12" />
          <line x1="3" y1="18" x2="3.01" y2="18" />
        </svg>
      </button>
    </div>
  );
}
